import { MODULES } from '../AIAssistant.constants'
import { AIRefine } from './AIRefine'
import { AIWrite } from './AIWrite'

const modulesMap = {
  [MODULES.AIWrite.id]: AIWrite,
  [MODULES.AIRefine.id]: AIRefine,
} as const

export { modulesMap }
